import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { BetSlipComponent } from '@shared/components/bet-slip/bet-slip.component';
import { BettingService } from '@services/mts/betting.service';
import { Outcome } from '@models/interfaces/outcome-dto';
import { AccountService } from '@services/account.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-betslip-modal-mobile',
    templateUrl: './betslip-modal-mobile.component.html',
    styleUrl: './betslip-modal-mobile.component.scss',

    imports: [CommonModule, BetSlipComponent, TranslocoModule],
})
export class BetslipModalMobileComponent {
    private bettingService = inject(BettingService);
    private accountService = inject(AccountService);
    isMobile = window.innerWidth < 768;
    oddType = this.bettingService.oddType;
    @HostListener('window:resize', ['$event'])
    onResize() {
        this.checkScreenSize();
    }
    private checkScreenSize() {
        this.isMobile = window.innerWidth <= 768;
    }

    localCurrency = this.accountService.localCurrency;
    @ViewChild('betsModal', { static: true }) betsModal!: ElementRef;

    ngOnInit() {
        this.checkScreenSize();
        this.bettingService.betsChanged$.subscribe({
            next: (res) => {
                if (res === undefined) {
                    const closeModalButton = document.getElementById('close-bet-modal-hidden');
                    closeModalButton?.click();
                }
            },
        });
    }
    getBets() {
        return this.bettingService.getBetslip();
    }

    calculateTotalOdds(bets: Outcome[]) {
        const totalOdd = bets.map((outcome) => outcome.decimalOdd).reduce((a, b) => a * b, 1);

        if (this.oddType() == 1) {
            return totalOdd.toFixed(2);
        } else {
            // Calculate the odd myself
            if (totalOdd >= 2) {
                return ((totalOdd - 1) * 100).toFixed(2);
            } else {
                return -(100 / (Math.abs(totalOdd) - 1)).toFixed(0);
            }
        }
    }

    displayIcon(bets: Outcome[]) {
        if (Math.abs(+this.calculateTotalOdds(bets)) > 50000) {
            return true;
        }
        return false;
    }

    getBalance() {
        return this.accountService.userSubject.getValue()?.balance;
    }

    closeModal() {
        this.bettingService.isNumpadOpen.next(false);
    }
}
